import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useParams } from "react-router-dom";

import ReactPlayer from "react-player";
import Highlighter from "react-highlight-words";

import moment from "moment";

import { isEdge, isSafari } from "react-device-detect";

import { message, Button, Card, Input, Modal, Table, Tooltip } from "antd";
import {
  SearchOutlined,
  PlaySquareOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import { getRobotVideos } from "../videos/videoSlice";

import LoadingPage from "../../components/LoadingPage";

import { fileSize } from "../../libs/utils";

// const VIDEO_PREFIX_OLD = "weld_vision.";
// const VIDEO_PREFIX_NEW = "NovEye.";

// NovEye with H265/HVEC is from '2.3.0'
const NOVEYE_H265_VERSION = "2.3.0";
const WARNING =
  "Of the desktop browsers only Microsoft Edge (version 16 and later) and Safari (version 11 and later) support H.265";

const VideosList = (props) => {
  const dispatch = useDispatch();
  const { robotName } = useParams();
  const robotId = robotName.match(/(\d+)/)[0];

  const videos = useSelector((state) => state.videos.videos);
  const robots = useSelector((state) => state.robot.robots);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchText, setSearchText] = useState("");

  const [selectedKeys, setSelectedKeys] = useState([]);

  const [pageNumber] = useState(1);
  const [defaultPageSize] = useState(12);

  const handleSearch = () => {
    setSearchText(selectedKeys);
  };

  const handleReset = () => {
    setSelectedKeys([]);
    setSearchText("");
  };

  const handleModalOpen = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
    // dispatch(getRobotNovEyeLog(item.download));
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  useEffect(() => {
    dispatch(getRobotVideos(robotId));
  }, [dispatch, robotId]);

  if (!(videos && robots)) {
    return <LoadingPage />;
  }

  const robot = robots.find((item) => item.name === robotName);

  const { versions = [] } = robot;
  const isNovEyeH265 = !!versions
    .filter((i) => {
      return i.name === "NovEye" || i.name === "WeldVision";
    })
    .map((i) => i.version)
    .find((i) => i >= NOVEYE_H265_VERSION);

  const filterVideos = () => {
    if (searchText === "") {
      return videos.map((item, index) => {
        return {
          key: index,
          name: item.fileName,
          size: item.size,
          date: item.uploadedAt,
          download: item.url,
        };
      });
    } else {
      return videos
        .map((item) =>
          item.fileName
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
            ? item
            : null
        )
        .filter((item) => item)
        .map((item, index) => {
          return {
            key: index,
            name: item.fileName,
            size: item.size,
            date: item.uploadedAt,
            download: item.url,
          };
        });
    }
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "name",
    },
    {
      title: "Size",
      render: (_, item) => <span>{fileSize(item.size)}</span>,
    },
    {
      title: "Uploaded At",
      key: "date",
      width: "20%",
      sorter: {
        compare: (a, b) => {
          const aString = a.date;
          const bString = b.date;

          if (aString > bString) {
            return 1;
          }
          if (aString < bString) {
            return -1;
          }
          return 0;
        },
      },
      render: (_, item) => (
        <span>{moment(item.date).format("YYYY-MM-DD, HH:mm:ss")}</span>
      ),
    },
    {
      title: "Play",
      render: (_, item) => (
        <PlaySquareOutlined onClick={() => handleModalOpen(item)} />
      ),
    },

    {
      title: "Download",
      dataIndex: "",
      key: "download",
      render: (item) => (
        <a
          href={item.download}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <DownloadOutlined />
        </a>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div style={{ marginBottom: 40 }}>
        <Input.Group className="VideosList_search-input">
          <Input
            placeholder={`Search ${selectedKeys}`}
            value={selectedKeys}
            onChange={(e) => {
              setSelectedKeys(e.target.value);
            }}
            onPressEnter={() => handleSearch()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />

          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys)}
            icon={<SearchOutlined />}
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset()} style={{ width: 90 }}>
            Clear
          </Button>
        </Input.Group>
      </div>

      <Table
        columns={columns}
        dataSource={filterVideos()}
        size="middle"
        pagination={{
          defaultPageSize: defaultPageSize,
          position: "bottom",
          pageNumber: pageNumber,
        }}
      />
      {modalOpen &&
        !!selectedItem &&
        (isNovEyeH265 && !(isEdge || isSafari) ? (
          message.error(WARNING, 5)
        ) : (
          <Modal
            title={selectedItem.name}
            visible={modalOpen}
            centered
            bodyStyle={{ height: "80%" }}
            width={"70%"}
            onOk={handleModalClose}
            onCancel={handleModalClose}
          >
            <VideoPlayer
              item={selectedItem}
              searchText={searchText}
              truncatedVideoName={""}
            />
          </Modal>
        ))}
    </React.Fragment>
  );
};

export const VideoPlayer = ({ item, searchText, truncatedVideoName }) =>
  item && (
    <Card
      title={
        <Tooltip title={item.name}>
          {item.name ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: "#ffc069",
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={item.name ? truncatedVideoName : ""}
            />
          ) : (
            <span>{truncatedVideoName}</span>
          )}
        </Tooltip>
      }
    >
      <ReactPlayer url={item.download} width={"100%"} controls></ReactPlayer>
    </Card>
  );

export default VideosList;
